import { useWindowSize } from 'react-use';

const useFixedWidthContainerSizeProps = ({
  sizes = `${100 - 3.333 * 2}vw`,
  maxWidth = 1400,
  width = maxWidth,
} = {}) => {
  const { width: windowWidth } = useWindowSize();

  if (windowWidth && windowWidth >= maxWidth) {
    return {
      sizes: `${Math.round((width / windowWidth) * 100)}vw`,
    };
  }

  return { sizes };
};

export default useFixedWidthContainerSizeProps;
